import React, { Component } from "react";
import { RiCloseCircleFill } from "react-icons/ri";
import { Redirect } from "react-router-dom";
import Swal from "sweetalert2";
import ImageProvider from "../../base/features/blocks/ImageProvider";
import BackButton from "../../base/features/micro/BackButton";
import { feedback } from "./services";

class Feedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: "",
      redirect: false,
      pending: false,
      images: [],
    };
  }
  sendFeedback() {
    this.setState({ pending: true });
    const formData = new FormData();
    formData.append("comment", this.state.comment);
    if (this.state.images.length > 0) {
      formData.append("image", this.state.images[0].file);
    }
    feedback(formData).then((items) => {
      items &&
        Swal.fire({
          icon: "success",
          text: "با موفقیت ثبت شد",
          timer: 2000,
          confirmButtonText: "تایید",
        }).then(() => this.setState({ redirect: true, pending: false }));
    });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect push to={"/setting"} />;
    }
    return (
      <div className="container-fluid">
        <header
          className="row mx-0 px-4 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0" }}
        >
          <div className="col-auto align-self-center px-0">
            <BackButton />
          </div>
          <div className="col text-start align-self-center px-0">
            <button
              onClick={() => this.sendFeedback()}
              className="btn fs-6 p-0 fw-bolder mb-0"
              disabled={!this.state.comment || this.state.pending}
            >
              {this.state.pending ? (
                <span className="spinner-border spinner-border-sm align-middle"></span>
              ) : (
                "ارسال"
              )}
            </button>
          </div>
        </header>
        <body style={{ marginTop: "80px" }}>
          <div className="row mx-0 px-0 mt-3">
            <div className="col-12 px-0">
              <p className="fw-bolder">بازخورد و نظر در مورد گیتی مارکت</p>
            </div>
            <div className="col-12 px-0">
              <textarea
                className="form-control rounded14 w-100 p-3"
                value={this.state.comment}
                onChange={(e) => this.setState({ comment: e.target.value })}
                rows="4"
                placeholder="هر نظر، مشکل و پیشنهادی در مورد گیتی مارکت"
              />
            </div>
          </div>
          <div className="row mx-0 px-0 mt-3">
            <div className="col-12 px-0">
              <p className="fw-bolder">افزودن عکس</p>
            </div>
            <div className="col-4 px-0">
              <ImageProvider
                images={this.state.images}
                updateImages={(images) => this.setState({ images: images })}
              />
            </div>
            {this.state.images.length > 0 &&
              this.state.images.map((image, i) => (
                <div
                  className="col-4 p-1 position-relative text-center rounded14 "
                  style={{ height: "100px" }}
                >
                  <img
                    alt="camera"
                    className="w-100 h-100 img-cover"
                    src={image.data_url}
                  />
                  <RiCloseCircleFill
                    onClick={() => this.setState({ images: [] })}
                    className="position-absolute text-muted"
                    style={{ top: "7px", right: "7px" }}
                    size="25"
                  />
                </div>
              ))}
          </div>
        </body>
      </div>
    );
  }
}

export default Feedback;
